import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const howToScoldChild: BlogMetaData = {
  title: '子どもの叱り方｜年齢別のコツ・NG例と叱った後のフォロー（モンテッソーリ流）',
  description:
    '子どもの叱り方に悩んでいませんか。年齢別に変える伝え方のコツ、感情的に怒鳴らないための工夫、避けたいNG対応をモンテッソーリの視点で解説。叱った後のフォローや相談先まで紹介します。',
  thumbnailUrl: '/img/blog-how-to-scold-child.webp',
  filePath: buildBlogFilePath('how-to-scold-child'),
  category: BLOG_CATEGORY.PARENTING,
};
